import { xhr } from '@/api/config/Repository'
import CreateCPRepository from '../CreateCPRepository'
import CreateCPRequestDTO from '../dto/CreateCPRequestDTO'
export default class CreateCPRepositoryImpl implements CreateCPRepository {
  async createCPData (request: CreateCPRequestDTO): Promise<any> {
    const endpoint = 'cp/createCashPenalty'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const formData = request.data
    const response = await xhr.post<any, any>(endpoint, formData, { headers })
    console.log('LOG~ ~ file: CreateCPRepositoryImpl.ts:12 ~ createCPData ~ response:', response)
    return {
      content: response.data,
      status: response.status
    }
  }
}
